import { render } from "./info.vue?vue&type=template&id=77489988&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=77489988&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77489988"]])

export default __exports__